<template>
  <router-view v-slot="{ Component }">
    <transition name="view" appear>
      <div class="apm">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import {
  TEMPLATE_APM,
  TEMPLATE_VM,
  CORRELATED_CAPABILITIES_APM,
} from '@/utils/constants';
export default {
  name: 'Apm',
  computed: {
    ...mapState('apmState/dashboard', ['currentTab']),
    ...mapState('apmState/apmCommonState', ['currentService', 'services']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
  },
  methods: {
    ...mapMutations('globalState/app', [
      'setChartsTemplate',
      'setTemplate',
      'setCorrelatedCapability',
      'toggleMenu',
      'setTemplate',
    ]),
    ...mapActions('apmState/apmCommonState', [
      'selectService',
      'getServiceLanguage',
    ]),
    async removeQuery() {
      const currentRoute = this.$route;

      await this.$router.replace({
        path: currentRoute.path,
        query: null,
      });
    },
  },
  watch: {
    currentTab(newValue) {
      if (newValue === 'Infrastructure') {
        this.setChartsTemplate(TEMPLATE_VM);
        this.setCorrelatedCapability(CORRELATED_CAPABILITIES_APM);
      } else {
        this.setTemplate(TEMPLATE_APM);
        this.setCorrelatedCapability('');
      }
    },
    currentService(newService) {
      this.getServiceLanguage({
        serviceId: newService?.key,
      });
    },
  },
  beforeMount() {
    const { serviceId, serviceName } = this.$route.query;

    if (serviceId && serviceName) {
      const appInfo = {
        key: serviceId,
        label: serviceName,
      };

      const params = {
        duration: this.getDurationTime,
        service: appInfo,
      };

      this.selectService(params);
      this.removeQuery();
    }

    if (this.currentTab === 'Infrastructure') {
      this.setChartsTemplate(TEMPLATE_VM);
    } else {
      this.setTemplate(TEMPLATE_APM);
    }
  },
  mounted() {
    this.getServiceLanguage();
  },
};
</script>

<style lang="scss" scoped>
.apm {
  width: 100%;
  height: 100%;
}
</style>
